import clone from 'lodash.clone'

import * as auth from '../auth'

import * as constants from './constants'

const initialState = {
    items: [],
}

const updateSingleItem = (items, item, properties) =>
    items.map(anItem =>
        anItem.id === item.id
            ? {
                  ...item,
                  ...properties,
              }
            : anItem
    )

const updateOrAddToBasket = (items, item) => {
    const index = items.findIndex(anItem => anItem.id === item.id)

    if (index === -1) {
        return [
            ...items,
            clone({
                ...item,
            }),
        ]
    } else {
        return updateSingleItem(items, item)
    }
}

export default function reducer(state = initialState, action) {
    const { item, type } = action
    const { items } = state

    switch (type) {
        case constants.ADD_TO_BASKET:
            return {
                items: updateOrAddToBasket(items, item),
            }

        case constants.REMOVE_FROM_BASKET:
            return {
                items: items.filter(anItem => anItem.id !== item.id),
            }

        case constants.PURCHASE_COMPLETED:
            return {
                items: [],
                purchaseCompleted: true,
            }

        case constants.EXTEND_PURCHASE_COMPLETED:
            return {
                items,
                purchaseCompleted: true,
            }

        case constants.CLEAR_PURCHASE_COMPLETED:
            return {
                items,
                purchaseCompleted: undefined,
            }

        case constants.SET_AUTO_RENEW:
            return {
                items: updateSingleItem(items, item, {
                    autoRenew: action.autoRenew,
                }),
            }

        case constants.REDEEMED_PROMO_CODE:
            return {
                items: updateSingleItem(items, item, {
                    promoCode: action.result,
                }),
            }

        case constants.REMOVE_PROMO_CODE:
            return {
                items: updateSingleItem(items, item, {
                    promoCode: undefined,
                }),
            }

        case auth.constants.LOGOUT:
        case constants.CLEAR_BASKET:
            return initialState

        default:
            return state
    }
}
